<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="username">
                                                {{ $t('label.username') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="username"
                                                    name="username"
                                                    id="username"
                                                    v-model="query.username"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "from_date"
                                                    v-model="query.from_date"
                                                    type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "to_date"
                                                    v-model="query.to_date"
                                                    type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="subject">
                                                {{ $t('customers_club.change_subject') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="subject"
                                                    class="form-control"
                                                    name="subject"
                                                    v-model="query.subject"
                                            >
                                                <option
                                                value="">
                                                    {{$t('selectpicker.nothing_selected') }}
                                                </option>
                                                <option
                                                        v-bind:key="subject"
                                                        v-for="subject in subjectTypes"
                                                        v-bind:value="subject"
                                                        :selected="query.subject === subject"
                                                >
                                                    {{ subjectTypeStr.get(subject) }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import {subjectTypeStr, subjectTypes} from '@/constants/UsersClubSubjectTypes'

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true
        }
    },
    data() {
        return {
            query: {},
            subjectTypeStr,
            subjectTypes,
        }
    },
    methods: {
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
    },
}

</script>